import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import React from "react";
import { StyledListTable } from "./CaseProgress.service";

/**
 * 案件進度查詢結果
 * @param {*} props 
 * @returns 
 */
const CaseProgressList = (props) => {
    return (
        <>
            <div className="form_white_box">
                <Grid
                    data={props.gridData}
                >
                    <GridNoRecords>查無案件</GridNoRecords>
                    <GridColumn title="收文文號" field="DocNo" width={120} />
                    <GridColumn title="來文日期" field="OrgSDate" width={120} />
                    <GridColumn title="申請單位" field="OrgNam" />
                    <GridColumn title="結案日期" field="FinTime" width={120} />
                    <GridColumn title="承辦人" field="UserNam" width={120} />
                    <GridColumn title="聯絡電話" field="Tel" width={120} />
                    <GridColumn title="處理情形" field="TrnSts" width={120} />
                </Grid>

                {/* <div className="" id="" >
                    <div className="table-responsive" >
                        <StyledListTable >
                            <tr>
                                <th style={{ width: '10%' }}>收文文號</th>
                                <th style={{ width: '10%' }}>來文日期</th>
                                <th style={{ width: '30%' }}>申請單位</th>
                                <th style={{ width: '10%' }}>結案日期</th>
                                <th style={{ width: '10%' }}>承辦人</th>
                                <th style={{ width: '15%' }}>聯絡電話</th>
                                <th style={{ width: '15%' }}>處理情形</th>

                            </tr>
                            {props.gridData && props.gridData.length > 0 ? props.gridData.map(item => {
                                return (
                                    <tr>
                                        <td>{item.DocNo}</td>
                                        <td>{item.OrgSDate}</td>
                                        <td>{item.OrgNam}</td>
                                        <td>{item.FinTime}</td>
                                        <td>{item.UserNam}</td>
                                        <td>{item.Tel}</td>
                                        <td>{item.TrnSts}</td>
                                    </tr>
                                )
                            })
                                :
                                <tr>
                                    <td colSpan={7}>
                                        <div style={{textAlign: 'center'}} >查無案件</div>
                                    </td>
                                </tr>
                            }
                        </StyledListTable>
                    </div>
                </div> */}

                <div className="items_folder_btn_box text-center mt-3">
                    <button className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md personal_Information_item" style={{ 'padding': '16px 36px', 'gap': '10px', 'background': 'rgb(0, 166, 152)', 'fontSize': '18px', 'fontWeight': '500', 'lineHeight': '26px', 'textAlign': 'center', 'color': 'rgb(255, 255, 255)' }} type="">
                        <span className="" onClick={() => { window.location.reload() }}>
                            重新查詢
                        </span>
                    </button>
                </div>
            </div>
        </>
    )
}

export default CaseProgressList